import styled from 'styled-components';
import { breakpoints } from '@/components/responsive';

export interface SpacingProps {
  value?: number | string;
  mobileValue?: number | string;
  xlrValue?: number | string;
}

const getSpacingCssValue = (value?: number | string) =>
  // eslint-disable-next-line no-nested-ternary
  value ? (typeof value === `number` ? `${value}rem` : value) : `1rem`;

export const HSpace = styled.div`
  height: 1px;
  width: ${(props: SpacingProps) => getSpacingCssValue(props.value)};
  flex-shrink: 0;
`;

export const VSpace = styled.div`
  height: ${(props: SpacingProps) => getSpacingCssValue(props.value)};
  width: 1px;
  flex-shrink: 0;

  ${breakpoints.down(`md`)} {
    height: ${(props: SpacingProps) =>
      getSpacingCssValue(props.mobileValue || props.value)};
  }

  ${breakpoints.up(`xlr`)} {
    height: ${(props: SpacingProps) =>
      getSpacingCssValue(props.xlrValue || props.value)};
  }
`;
